// extracted by mini-css-extract-plugin
export var cartIcon = "_ml-0";
export var cartIconContainer = "_ml-1";